import { TaskCategoryTaskType } from '@urbanx/agx.activities.client';

export type ExchangeTaskFamily = 'solicitor' | 'agent' | 'contract';

type ExchangeTaskSource = {
  category?: {
    taskType?: TaskCategoryTaskType;
  };
};

export const exchangeTaskTypes = [
  TaskCategoryTaskType.SolicitorExchangeInformation,
  TaskCategoryTaskType.SolicitorExchangeContractDates,
  TaskCategoryTaskType.AgentExchangeInformation,
  TaskCategoryTaskType.AgentExchangeContractDates,
  TaskCategoryTaskType.ContractExchangeInformation,
  TaskCategoryTaskType.ContractExchangeContractDates,
] as const;

export const isExchangeTaskType = (taskType?: TaskCategoryTaskType) =>
  !!taskType && exchangeTaskTypes.includes(taskType as (typeof exchangeTaskTypes)[number]);

export const isExchangeInformationTaskType = (taskType?: TaskCategoryTaskType) =>
  taskType === TaskCategoryTaskType.SolicitorExchangeInformation ||
  taskType === TaskCategoryTaskType.AgentExchangeInformation ||
  taskType === TaskCategoryTaskType.ContractExchangeInformation;

export const isExchangeContractDatesTaskType = (taskType?: TaskCategoryTaskType) =>
  taskType === TaskCategoryTaskType.SolicitorExchangeContractDates ||
  taskType === TaskCategoryTaskType.AgentExchangeContractDates ||
  taskType === TaskCategoryTaskType.ContractExchangeContractDates;

export const getExchangeTaskFamily = (
  taskType?: TaskCategoryTaskType
): ExchangeTaskFamily | undefined => {
  switch (taskType) {
    case TaskCategoryTaskType.SolicitorExchangeInformation:
    case TaskCategoryTaskType.SolicitorExchangeContractDates:
      return 'solicitor';
    case TaskCategoryTaskType.AgentExchangeInformation:
    case TaskCategoryTaskType.AgentExchangeContractDates:
      return 'agent';
    case TaskCategoryTaskType.ContractExchangeInformation:
    case TaskCategoryTaskType.ContractExchangeContractDates:
      return 'contract';
    default:
      return undefined;
  }
};

export const getExchangeDisplayTask = <T extends ExchangeTaskSource>(tasks: T[]) =>
  tasks.find((task) => isExchangeInformationTaskType(task.category?.taskType)) ?? tasks[0];

export const getExchangeTaskTitle = (family: ExchangeTaskFamily) => {
  switch (family) {
    case 'solicitor':
      return 'Solicitor Exchange';
    case 'agent':
      return 'Agent Exchange';
    case 'contract':
      return 'Contract Exchange';
  }
};
